import _toConsumableArray from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _extends from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["className"],
  _excluded2 = ["label", "field", "value", "linkCallback", "variant", "separator", "wrapperProps"];
var __jsx = React.createElement;
import React from "react";
import MUIBox from "@mui/material/Box";
import { ELSTypography } from "../Typography/Typography";

/**
 * Wraps MUIBox component - https://mui.com/components/box/#api.
 * @param {wrapperProps} wrapperProps Wrapper props for the MUIBox
 * @param {props} props Props for the MUIBox itself ("component", "sx", etc)
 * @returns JSX representing the data
 */
export var ELSBox = function ELSBox(_ref) {
  var className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(MUIBox, _extends({
    className: "es--box ".concat(className || "")
  }, props), props.children);
};
ELSBox.defaultProps = {};

/*
 * Wraps MUIBox component - https://mui.com/components/box/#api.
 * @param {wrapperProps} wrapperProps Wrapper props for the MUIBox
 * @param {props} props Props for the MUIBox itself ("component", "sx", etc)
 * @param {variant} variant - Can be "single" or "multi" to indicate if the label/value pair is single line or multi line
 * @param {field} field - field name - will be used in the element class name and passed as param if search link is used
 * @param {label} label - label for metadata
 * @param {value} value - metadata value, see "type" for types of values.  CAN BE EMPTY!
 * @returns JSX representing the data
 */
export var ELSLabelValueBox = function ELSLabelValueBox(_ref2) {
  var label = _ref2.label,
    field = _ref2.field,
    value = _ref2.value,
    linkCallback = _ref2.linkCallback,
    variant = _ref2.variant,
    separator = _ref2.separator,
    wrapperProps = _ref2.wrapperProps,
    props = _objectWithoutProperties(_ref2, _excluded2);
  // Build the output value line
  var buildValueLine = function buildValueLine() {
    var values = [];
    if (!(value instanceof Array)) values = [value];else values = _toConsumableArray(value);
    // if (!(value instanceof Array)) value = [value];
    /* eslint-disable react/no-array-index-key */
    return /*#__PURE__*/React.createElement("span", {
      className: "ev__valuewrapper"
    }, values.map(function (v, index, arr) {
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: "".concat(field, ":").concat(index)
      }, linkCallback(field, v, label), arr.length > index + 1 && /*#__PURE__*/React.createElement(ELSTypography, {
        component: "span",
        className: "ev--separator"
      }, separator));
    }));
  };

  // Return JSX
  try {
    if (!value || value.length === 0) return null;
    return /*#__PURE__*/React.createElement("div", _extends({
      className: "es--labelvalue-box ev__".concat(variant, " ev__field-").concat(field === null || field === void 0 ? void 0 : field.toLowerCase())
    }, wrapperProps), /*#__PURE__*/React.createElement(MUIBox, _extends({}, props, {
      sx: {
        display: "inherit",
        flexDirection: "inherit"
      }
    }), label && label.length > 0 && /*#__PURE__*/React.createElement(ELSTypography, {
      component: "span",
      className: "ev__label"
    }, label), buildValueLine()));
  } catch (err) {
    console.error("Unable to output ", field, ", value=", JSON.stringify(value), ", error=", err);
    return null;
  }
};

/* Build the output value line */
var buildValueOnly = function buildValueOnly(field, value) {
  return /*#__PURE__*/React.createElement(ELSTypography, {
    className: "ev__value",
    component: "span",
    dangerouslySetInnerHTML: {
      __html: value
    }
  });
};
ELSLabelValueBox.defaultProps = {
  field: "none",
  label: "",
  variant: "single",
  separator: " - ",
  attributes: {},
  linkCallback: buildValueOnly
};